import { CheckIcon } from "@heroicons/react/24/outline";
import React from "react";

import { Input } from "@fronterahealth/frontera-ui-components";

import { DateRangeFilter } from "@pages/ClinicalReportDetails/ReportPage/Components/GoalsFilterPopover";

const DATE_RANGE_PRESETS = [
  { id: "last30", label: "Last 30 days" },
  { id: "last60", label: "Last 60 days" },
  { id: "last90", label: "Last 90 days" },
  { id: "last6months", label: "Last 6 months" },
  { id: "last12months", label: "Last 12 months" },
  { id: "custom", label: "Custom" },
];

interface GoalsFilterDateRangeSubPanelProps {
  value: DateRangeFilter;
  onChange: (value: DateRangeFilter) => void;
  onClear: () => void;
}

export const GoalsFilterDateRangeSubPanel: React.FC<GoalsFilterDateRangeSubPanelProps> = ({
  value,
  onChange,
  onClear,
}) => {
  const isCustom = value.preset === "custom";
  const hasValue = value.preset !== null;

  const handlePresetClick = (id: string) => {
    if (id === "custom") {
      onChange({ ...value, preset: "custom" });
    } else {
      onChange({ preset: id, startDate: null, endDate: null });
    }
  };

  return (
    <div className="absolute left-full top-0 z-50 ml-1 flex rounded-lg border border-limestone-100 bg-white shadow-[0px_6px_12px_0px_rgba(0,0,0,0.12)]">
      {/* Preset list */}
      <div className="w-[205px] py-2">
        {DATE_RANGE_PRESETS.map((preset) => (
          <div key={preset.id} className="px-2 py-1">
            <button
              className="flex w-full items-center justify-between rounded-sm p-1 hover:bg-limestone-50"
              onClick={() => handlePresetClick(preset.id)}
            >
              <span className="text-sm font-normal leading-[22px] text-limestone-900">{preset.label}</span>
              {value.preset === preset.id && <CheckIcon className="h-4 w-4 text-green-600" />}
            </button>
          </div>
        ))}
        {hasValue && !isCustom && (
          <div className="mx-4 mt-1 flex flex-col gap-2">
            <div className="h-px w-full bg-limestone-200" />
            <button
              className="text-left text-sm font-semibold leading-[22px] text-green-700 hover:text-green-800"
              onClick={onClear}
            >
              Clear
            </button>
          </div>
        )}
      </div>

      {/* Custom date inputs */}
      {isCustom && (
        <div className="flex flex-col items-end gap-2 border-l border-limestone-100 p-4">
          <div className="flex gap-2">
            <div className="w-[160px]">
              <Input
                name="startDate"
                label="Start Date"
                type="date"
                value={value.startDate ?? ""}
                onChange={(e) => onChange({ ...value, startDate: e.target.value || null })}
                inputSize="full"
                formNoValidate
              />
            </div>
            <div className="w-[160px]">
              <Input
                name="endDate"
                label="End date"
                type="date"
                value={value.endDate ?? ""}
                onChange={(e) => onChange({ ...value, endDate: e.target.value || null })}
                inputSize="full"
                formNoValidate
              />
            </div>
          </div>
          <button
            className="text-sm font-semibold leading-[22px] text-green-700 hover:text-green-800"
            onClick={onClear}
          >
            Clear
          </button>
        </div>
      )}
    </div>
  );
};
